function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * @module ol/source/Image
 */
import ImageWrapper from '../Image.js';
import ImageState from '../ImageState.js';
import { linearFindNearest } from '../array.js';
import Event from '../events/Event.js';
import EventType from '../events/EventType.js';
import { containsExtent, equals, getCenter, getForViewAndSize, getHeight, getWidth } from '../extent.js';
import { ceil } from '../math.js';
import { equivalent } from '../proj.js';
import ReprojImage from '../reproj/Image.js';
import { fromResolutionLike } from '../resolution.js';
import Source from './Source.js';
import { DECIMALS } from './common.js';

/**
 * @enum {string}
 */
export var ImageSourceEventType = {
  /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */
  IMAGELOADSTART: 'imageloadstart',
  /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */
  IMAGELOADEND: 'imageloadend',
  /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */
  IMAGELOADERROR: 'imageloaderror'
};

/**
 * @typedef {'imageloadend'|'imageloaderror'|'imageloadstart'} ImageSourceEventTypes
 */

/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Image~ImageSource} instances are instances of this
 * type.
 */
export var ImageSourceEvent = /*#__PURE__*/function (_Event) {
  /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */
  function ImageSourceEvent(type, image) {
    var _this;
    _classCallCheck(this, ImageSourceEvent);
    _this = _callSuper(this, ImageSourceEvent, [type]);

    /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */
    _this.image = image;
    return _this;
  }
  _inherits(ImageSourceEvent, _Event);
  return _createClass(ImageSourceEvent);
}(Event);

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */

/**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */
var ImageSource = /*#__PURE__*/function (_Source) {
  /**
   * @param {Options} options Single image source options.
   */
  function ImageSource(options) {
    var _this2;
    _classCallCheck(this, ImageSource);
    _this2 = _callSuper(this, ImageSource, [{
      attributions: options.attributions,
      projection: options.projection,
      state: options.state,
      interpolate: options.interpolate !== undefined ? options.interpolate : true
    }]);

    /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */
    _this2.on;

    /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */
    _this2.once;

    /***
     * @type {ImageSourceOnSignature<void>}
     */
    _this2.un;

    /**
     * @protected
     * @type {import("../Image.js").Loader}
     */
    _this2.loader = options.loader || null;

    /**
     * @private
     * @type {Array<number>|null}
     */
    _this2.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;

    /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */
    _this2.reprojectedImage_ = null;

    /**
     * @private
     * @type {number}
     */
    _this2.reprojectedRevision_ = 0;

    /**
     * @protected
     * @type {import("../Image.js").default}
     */
    _this2.image = null;

    /**
     * @private
     * @type {import("../extent.js").Extent}
     */
    _this2.wantedExtent_;

    /**
     * @private
     * @type {number}
     */
    _this2.wantedResolution_;

    /**
     * @private
     * @type {boolean}
     */
    _this2.static_ = options.loader ? options.loader.length === 0 : false;

    /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */
    _this2.wantedProjection_ = null;
    return _this2;
  }

  /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */
  _inherits(ImageSource, _Source);
  return _createClass(ImageSource, [{
    key: "getResolutions",
    value: function getResolutions() {
      return this.resolutions_;
    }

    /**
     * @param {Array<number>|null} resolutions Resolutions.
     */
  }, {
    key: "setResolutions",
    value: function setResolutions(resolutions) {
      this.resolutions_ = resolutions;
    }

    /**
     * @protected
     * @param {number} resolution Resolution.
     * @return {number} Resolution.
     */
  }, {
    key: "findNearestResolution",
    value: function findNearestResolution(resolution) {
      var resolutions = this.getResolutions();
      if (resolutions) {
        var idx = linearFindNearest(resolutions, resolution, 0);
        resolution = resolutions[idx];
      }
      return resolution;
    }

    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     */
  }, {
    key: "getImage",
    value: function getImage(extent, resolution, pixelRatio, projection) {
      var _this3 = this;
      var sourceProjection = this.getProjection();
      if (!sourceProjection || !projection || equivalent(sourceProjection, projection)) {
        if (sourceProjection) {
          projection = sourceProjection;
        }
        return this.getImageInternal(extent, resolution, pixelRatio, projection);
      }
      if (this.reprojectedImage_) {
        if (this.reprojectedRevision_ == this.getRevision() && equivalent(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && equals(this.reprojectedImage_.getExtent(), extent)) {
          return this.reprojectedImage_;
        }
        this.reprojectedImage_.dispose();
        this.reprojectedImage_ = null;
      }
      this.reprojectedImage_ = new ReprojImage(sourceProjection, projection, extent, resolution, pixelRatio, function (extent, resolution, pixelRatio) {
        return _this3.getImageInternal(extent, resolution, pixelRatio, sourceProjection);
      }, this.getInterpolate());
      this.reprojectedRevision_ = this.getRevision();
      return this.reprojectedImage_;
    }

    /**
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     * @protected
     */
  }, {
    key: "getImageInternal",
    value: function getImageInternal(extent, resolution, pixelRatio, projection) {
      if (this.loader) {
        var requestExtent = getRequestExtent(extent, resolution, pixelRatio, 1);
        var requestResolution = this.findNearestResolution(resolution);
        if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && containsExtent(this.wantedExtent_, requestExtent) || containsExtent(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && fromResolutionLike(this.wantedResolution_) === requestResolution || fromResolutionLike(this.image.getResolution()) === requestResolution))) {
          return this.image;
        }
        this.wantedProjection_ = projection;
        this.wantedExtent_ = requestExtent;
        this.wantedResolution_ = requestResolution;
        this.image = new ImageWrapper(requestExtent, requestResolution, pixelRatio, this.loader);
        this.image.addEventListener(EventType.CHANGE, this.handleImageChange.bind(this));
      }
      return this.image;
    }

    /**
     * Handle image change events.
     * @param {import("../events/Event.js").default} event Event.
     * @protected
     */
  }, {
    key: "handleImageChange",
    value: function handleImageChange(event) {
      var image = /** @type {import("../Image.js").default} */event.target;
      var type;
      switch (image.getState()) {
        case ImageState.LOADING:
          this.loading = true;
          type = ImageSourceEventType.IMAGELOADSTART;
          break;
        case ImageState.LOADED:
          this.loading = false;
          type = ImageSourceEventType.IMAGELOADEND;
          break;
        case ImageState.ERROR:
          this.loading = false;
          type = ImageSourceEventType.IMAGELOADERROR;
          break;
        default:
          return;
      }
      if (this.hasListener(type)) {
        this.dispatchEvent(new ImageSourceEvent(type, image));
      }
    }
  }]);
}(Source);
/**
 * Default image load function for image sources that use import("../Image.js").Image image
 * instances.
 * @param {import("../Image.js").default} image Image.
 * @param {string} src Source.
 */
export function defaultImageLoadFunction(image, src) {
  /** @type {HTMLImageElement|HTMLVideoElement} */image.getImage().src = src;
}

/**
 * Adjusts the extent so it aligns with pixel boundaries.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} resolution Reolution.
 * @param {number} pixelRatio Pixel ratio.
 * @param {number} ratio Ratio between request size and view size.
 * @return {import("../extent.js").Extent} Request extent.
 */
export function getRequestExtent(extent, resolution, pixelRatio, ratio) {
  var imageResolution = resolution / pixelRatio;
  var center = getCenter(extent);
  var viewWidth = ceil(getWidth(extent) / imageResolution, DECIMALS);
  var viewHeight = ceil(getHeight(extent) / imageResolution, DECIMALS);
  var marginWidth = ceil((ratio - 1) * viewWidth / 2, DECIMALS);
  var requestWidth = viewWidth + 2 * marginWidth;
  var marginHeight = ceil((ratio - 1) * viewHeight / 2, DECIMALS);
  var requestHeight = viewHeight + 2 * marginHeight;
  return getForViewAndSize(center, imageResolution, 0, [requestWidth, requestHeight]);
}
export default ImageSource;